import { faqData } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <h2 className="section-title">常见问题</h2>
        <p className="section-subtitle">关于97影视的常见疑问，这里有你想知道的答案</p>

        <div className="max-w-3xl mx-auto space-y-4">
          {faqData.map((item) => (
            <article
              key={item.question}
              className="bg-background-100 border border-background-200/70 rounded-lg p-5 md:p-6"
            >
              <h3 className="text-base md:text-lg font-heading text-foreground-950">
                {item.question}
              </h3>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                {item.answer}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}